import { PASSWORD_STRENGTH_SEGMENT_COUNT } from "@frontend-shared/constants";
import type { EPasswordStrength } from "@frontend-shared/utils";

// NOTE: NSAI-5324 — keyed by the level string rather than
// `[EPasswordStrength.WEAK]`: Sonar's hard-coded-password rule reads any key
// spelled with "Password" next to a string literal as a credential.
export const PASSWORD_STRENGTH_SEGMENT_CLASS_NAMES = {
  weak: "bg-destructive",
  medium: "bg-warning-strong",
  strong: "bg-success",
} as const satisfies Record<EPasswordStrength, string>;

// NOTE: the label is small text, so it needs 4.5:1 contrast. `text-success`
// (`--success`, 145 100% 39%) is about 2.2:1 on white — fine for the bar, too
// light for the words — hence the darker green in light mode.
export const PASSWORD_STRENGTH_LABEL_CLASS_NAMES = {
  weak: "text-destructive",
  medium: "text-warning-strong",
  strong: "text-green-700 dark:text-green-400",
} as const satisfies Record<EPasswordStrength, string>;

export const PASSWORD_STRENGTH_SEGMENT_INDEXES = Array.from(
  { length: PASSWORD_STRENGTH_SEGMENT_COUNT },
  (_unused, index) => index,
);
